import React from 'react';
import { DEFAULT_AI_TEST_MESSAGE } from '../../utils/kbTestPayload';

export default function TestAIConversation({
  testLeadName,
  setTestLeadName,
  testLeadEmail,
  setTestLeadEmail,
  testLeadMessage,
  setTestLeadMessage,
  conversationHistory = [],
  setConversationHistory,
  setAiReplyPreview,
  testingAiReply,
  onTest,
  onDownload,
  showDownload = true,
}) {
  return (
    <div
      id="test-ai-conversation"
      data-testid="test-ai-conversation"
      className="fb-card fb-card-accent"
      style={{ marginBottom: '2rem' }}
    >
      <h3 className="fb-subsection-title" style={{ marginTop: 0 }}>Test AI Conversation</h3>
      <p className="fb-muted" style={{ marginBottom: '1.5rem' }}>
        Simulate a conversation with AI to see what leads will receive:
      </p>

      {conversationHistory.length > 0 && (
        <div style={{ marginBottom: '2rem' }}>
          <h4 style={{ marginTop: 0 }}>Conversation:</h4>
          {conversationHistory.map((turn, i) => (
            <div key={i} style={{ marginBottom: '1.5rem' }}>
              <div className="fb-convo-lead">
                <strong>Lead (Turn {turn.turn}):</strong>
                <div style={{ marginTop: '0.5rem', color: '#333' }}>{turn.leadMessage}</div>
              </div>
              <div className="fb-convo-ai">
                <strong>AI Reply:</strong>
                <div style={{ marginTop: '0.5rem', color: '#333', whiteSpace: 'pre-wrap', fontSize: '0.9rem' }}>
                  {turn.aiReply}
                </div>
              </div>
              {turn.groundingNote && (
                <div className="fb-callout info" data-testid="grounding-guidance" style={{ marginTop: '0.75rem' }}>
                  {turn.groundingNote}
                </div>
              )}
            </div>
          ))}
        </div>
      )}

      <div className="fb-stack-col">
        <div>
          <label className="fb-label">Lead Name</label>
          <input
            type="text"
            value={testLeadName}
            onChange={(e) => setTestLeadName(e.target.value)}
            placeholder="Sarah Johnson"
            className="fb-input"
          />
        </div>

        <div>
          <label className="fb-label">Lead Email</label>
          <input
            type="email"
            value={testLeadEmail}
            onChange={(e) => setTestLeadEmail(e.target.value)}
            placeholder="sarah@example.com"
            className="fb-input"
          />
        </div>

        <div>
          <label className="fb-label">
            {conversationHistory.length === 0 ? 'Initial Message' : 'Next Message'}
          </label>
          <textarea
            value={testLeadMessage}
            onChange={(e) => setTestLeadMessage(e.target.value)}
            placeholder={conversationHistory.length === 0
              ? DEFAULT_AI_TEST_MESSAGE
              : "Lead's follow-up question..."}
            rows="3"
            className="fb-textarea"
          />
        </div>

        <button
          type="button"
          className="inbox-pill-btn-primary"
          onClick={onTest}
          disabled={!testLeadMessage || testingAiReply}
          style={{ width: '100%', padding: '1rem', fontSize: '1.1rem', opacity: testingAiReply || !testLeadMessage ? 0.6 : 1, cursor: testingAiReply || !testLeadMessage ? 'not-allowed' : 'pointer' }}
        >
          {testingAiReply ? 'Generating...' : conversationHistory.length === 0 ? 'Preview AI Reply' : 'Continue Conversation'}
        </button>

        {conversationHistory.length > 0 && (
          <>
            <button
              type="button"
              className="fb-btn-ghost-sm"
              onClick={() => {
                setConversationHistory([]);
                setAiReplyPreview?.(null);
                setTestLeadMessage(DEFAULT_AI_TEST_MESSAGE);
              }}
              style={{ width: '100%', padding: '0.75rem', marginBottom: '0.5rem' }}
            >
              Reset Conversation
            </button>

            {showDownload && onDownload && (
              <button
                type="button"
                className="inbox-pill-btn-primary"
                onClick={onDownload}
                style={{ width: '100%', padding: '1rem' }}
              >
                Download Conversation
              </button>
            )}
          </>
        )}
      </div>
    </div>
  );
}
